import { useState } from "react";
import {
  Box,
  Avatar,
  Button,
  Typography,
  Paper,
  Chip,
} from "@material-ui/core";
import { Edit as EditIcon } from "@material-ui/icons";
import { formatRut, RutFormat } from "@fdograph/rut-utilities";
import PropTypes from "prop-types";
import EditarSolicitanteDialog from "src/components/propuesta/EditarSolicitanteDialog";
import { BRAND } from "src/theme/brandTokens";

/**
 * Tarjeta de contexto con los datos del solicitante actual del BORRADOR.
 * Aparece arriba del Autocomplete de selección. Permite editar el solicitante
 * si tiene id (es decir, existe en la BD).
 */
const SolicitanteActualCard = ({ solicitante, onSolicitanteActualizado }) => {
  const [openEditar, setOpenEditar] = useState(false);

  if (!solicitante) {
    return (
      <Paper variant="outlined" sx={{ p: 2, mb: 2, borderStyle: "dashed" }}>
        <Typography variant="body2" color="textSecondary">
          No hay solicitante asignado a este borrador. Usa el buscador abajo
          para asignar uno o crear uno nuevo.
        </Typography>
      </Paper>
    );
  }

  const inicial = solicitante.nombre?.charAt(0).toUpperCase() || "?";
  const rutFmt = solicitante.rut
    ? formatRut(solicitante.rut, RutFormat.DOTS_DASH)
    : null;

  return (
    <>
      <Paper
        variant="outlined"
        sx={{ p: 2, mb: 2, display: "flex", gap: 2, alignItems: "center" }}
      >
        <Avatar sx={{ width: 48, height: 48, bgcolor: BRAND.color.primary }}>
          {inicial}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ fontWeight: 600, textTransform: "uppercase" }}
          >
            Solicitante actual
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {solicitante.nombre}
          </Typography>
          {solicitante.correo && (
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{ display: "block" }}
            >
              {solicitante.correo}
            </Typography>
          )}
          {rutFmt ? (
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{ display: "block" }}
            >
              RUT: {rutFmt}
            </Typography>
          ) : (
            <Chip
              label="Sin RUT"
              size="small"
              sx={{
                mt: 0.5,
                bgcolor: BRAND.color.primary,
                color: "#fff",
                height: 18,
                fontSize: 10,
              }}
            />
          )}
        </Box>
        {/* Botón de edición disponible solo para solicitantes ya persistidos en BD */}
        {solicitante.id && (
          <Button
            size="small"
            startIcon={<EditIcon fontSize="small" />}
            onClick={() => setOpenEditar(true)}
            sx={{ textTransform: "none", flexShrink: 0 }}
          >
            Editar
          </Button>
        )}
      </Paper>

      <EditarSolicitanteDialog
        open={openEditar}
        onClose={() => setOpenEditar(false)}
        solicitante={solicitante}
        onSaved={(actualizado) => {
          setOpenEditar(false);
          onSolicitanteActualizado?.(actualizado);
        }}
      />
    </>
  );
};

SolicitanteActualCard.propTypes = {
  solicitante: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nombre: PropTypes.string,
    correo: PropTypes.string,
    rut: PropTypes.string,
    telefono: PropTypes.string,
  }),
  onSolicitanteActualizado: PropTypes.func,
};

SolicitanteActualCard.defaultProps = {
  solicitante: null,
  onSolicitanteActualizado: undefined,
};

export default SolicitanteActualCard;
